import BioGraficoPainel from "entity/Indicador/Bio/components/BioGraficoPainel"
import CMGraficoPainel from "entity/Indicador/CM/components/CMGraficoPainel"
import MMGraficoPainel from "entity/Indicador/MM/components/MMGraficoPainel"
import PerfGraficoPainel from "entity/Indicador/Perf/components/PerfGraficoPainel"
import TMMGraficoPainel from "entity/Indicador/TMM/components/TMMGraficoPainel"
import TMTGraficoPainel from "entity/Indicador/TMT/components/TMTGraficoPainel"
import TTCGraficoPainel from "entity/Indicador/TTC/components/TTCGraficoPainel"
import { GraficoPadrao } from "entity/Indicador/components/GraficoPadraoPainel"

export default function GraficosPainel({ mediaAgrupadorList, fullName, nomeAgrupador, meta, field }) {
    switch (field) {
        case 'bio':
            return <BioGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
        case 'cm':
            return <CMGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
        case 'mudaMecanizada':
            return <MMGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
        case 'perf':
            return <PerfGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
        case 'tmm':
            return <TMMGraficoPainel mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
        case 'tmt':
            return <TMTGraficoPainel mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
        case 'ttc':
            return <TTCGraficoPainel mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
        default:
            return <GraficoPadrao mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} />
    }
}